import CustomContentService from '@/services/api/custom-content/custom-content-service.js';

const state = {
  customContent: [],
  uploading: false,
};

const getters = {
  customContent: state => state.customContent,
  uploading: state => state.uploading,
  customContentById: state => syncguid => {
    return state.customContent.find(c => c.syncguid === syncguid);
  },
};

const mutations = {
  setCustomContentObject: (state, { syncguid, key, object }) => {
    const found = state.customContent.find(c => c.syncguid === syncguid);
    if (found) {
      found[key] = object;
    } else {
      const newContent = { syncguid };
      newContent[key] = object;
      state.customContent.push(newContent);
    }
  },
  removeCustomContentItem: (state, { key, item, syncguid }) => {
    const content = state.customContent.find(c => c.syncguid === syncguid);
    if (content) {
      content[key] = content[key].filter(i => i !== item);
    }
  },
  removeInteraction: (state, { id, syncguid }) => {
    const content = state.customContent.find(c => c.syncguid === syncguid);
    if (content) {
      content.interactions = content.interactions.filter(i => i.nid !== id);
    }
  },
  removeQuizQuestion: (state, { item, syncguid }) => {
    const content = state.customContent.find(c => c.syncguid === syncguid);
    if (content) {
      content.quiz.questions = content.quiz.questions.filter(i => i.id !== item.id);
    }
  },
  addQuizQuestion: (state, { item, syncguid }) => {
    const content = state.customContent.find(c => c.syncguid === syncguid);
    if (content) {
      content.quiz.questions.push(item);
    }
  },
  removeThumbnail: (state, { syncguid }) => {
    const content = state.customContent.find(c => c.syncguid === syncguid);
    if (content) {
      content.thumbnail = undefined;
    }
  },
  setUploading: (state, val) => {
    state.uploading = val;
  },
};

const actions = {
  getCustomContentObject({ getters, commit }, { syncguid, key }) {
    const found = getters.customContent.find(c => c.syncguid === syncguid);
    if (found && found[key] && found[key].video_processed) {
      return new Promise(resolve => {
        resolve(found[key]);
      });
    } else {
      const method = `get${key.charAt(0).toUpperCase() + key.slice(1)}`;
      return CustomContentService[method](syncguid).then(object => {
        commit('setCustomContentObject', { syncguid, key, object });
        return object;
      });
    }
  },
  patchCustomContentObject({ getters, commit }, { syncguid, key, body }) {
    const method = `patch${key.charAt(0).toUpperCase() + key.slice(1)}`;
    return CustomContentService[method](syncguid, body).then(() => {
      const found = getters.customContent.find(c => c.syncguid === syncguid);
      if (found) {
        const object = { ...found[key], ...body };
        commit('setCustomContentObject', { syncguid, key, object });
      }
    });
  },
  uploadVideo({ commit }, { url, file, headers }) {
    commit('setUploading', true);
    return CustomContentService.uploadVideo(url, file, headers).then(() => {
      $('.ui.toast').toast('close');
      $('body').toast({
        class: 'success',
        message: 'Upload complete.  Your video is currently processing and will be available shortly.',
      });
    }).catch(() => {
      $('.ui.toast').toast('close');
      $('body').toast({
        class: 'error',
        message: 'An error occurred while uploading the video.',
      });
    }).finally(() => {
      commit('setUploading', false);
    });
  },
  patchCustomContentInteractions({ getters, commit }, { syncguid, body }) {
    return CustomContentService.patchInteractions(syncguid, body).then(() => {
      const found = getters.customContent.find(c => c.syncguid === syncguid);
      if (found) {
        const object = [...found.interactions];
        body.forEach(item => {
          const itemToReplace = object.findIndex(o => o.nid === item.nid);
          if (itemToReplace > -1) {
            object.splice(itemToReplace, 1, { ...item, data: JSON.parse(item.data) });
          }
        });
        commit('setCustomContentObject', { syncguid, key: 'interactions', object });
      }
    });
  },
  addInteractions({ commit }, { syncguid, interactions }) {
    const body = interactions.map(i => {
      return {
        data: i.data,
        time: i.time,
        title: i.title,
        type: i.type,
      };
    });
    return CustomContentService.postInteractions(syncguid, body).then(() => {
      commit('setCustomContentObject', {
        syncguid,
        key: 'interactions',
        object: body,
      });
    });
  },
  deleteInteractions({ commit }, { syncguid, interactions }) {
    const body = interactions.map(i => i.nid);
    return CustomContentService.deleteInteractions(syncguid, body).then(() => {
      body.forEach(id => {
        commit('removeInteraction', {
          id,
          syncguid,
        });
      });
    });
  },
  postCaptions({ commit }, { syncguid, captions }) {
    return CustomContentService.postCaptions(syncguid, { data: captions }).then(() => {
      commit('setCustomContentObject', { syncguid, key: 'captions', object: captions });
      return captions;
    });
  },
  patchCaptions({ commit }, { syncguid, captions }) {
    return CustomContentService.patchCaptions(syncguid, { data: captions }).then(() => {
      commit('setCustomContentObject', { syncguid, key: 'captions', object: captions });
      return captions;
    });
  },
  deleteCaptions({ commit }, { syncguid }) {
    return CustomContentService.deleteCaptions(syncguid).then(() => {
      commit('setCustomContentObject', { syncguid, key: 'captions', object: [] });
    });
  },
  addQuiz({ commit }, { syncguid, quiz }) {
    return CustomContentService.postQuiz(syncguid, quiz).then(() => {
      commit('setCustomContentObject', { syncguid, key: 'quiz', object: quiz });
    });
  },
  deleteQuiz({ commit }, { syncguid }) {
    return CustomContentService.deleteQuiz(syncguid).then(() => {
      commit('setCustomContentObject', { syncguid, key: 'quiz', object: {} });
    });
  },
  deleteQuestions({ commit }, { syncguid, questions }) {
    const arr = questions.map(i => i.id);
    return CustomContentService.deleteQuestions(syncguid, arr).then(() => {
      questions.forEach(item => {
        commit('removeQuizQuestion', {
          item,
          syncguid,
        });
      });
    });
  },
  addQuestions({ commit }, { syncguid, questions }) {
    return CustomContentService.postQuestions(syncguid, questions).then(() => {
      questions.forEach(item => {
        commit('addQuizQuestion', {
          item,
          syncguid,
        });
      });
    });
  },
  patchQuestions({ getters, commit }, { syncguid, questions }) {
    return CustomContentService.patchQuestions(syncguid, questions);
  },
  deleteSupportMaterials({ commit }, { syncguid, files }) {
    return CustomContentService.deleteSupportMaterials(syncguid, files).then(() => {
      files.forEach(item => {
        commit('removeCustomContentItem', {
          key: 'supportMaterials',
          item,
          syncguid,
        });
      });
    });
  },
  addSupportMaterials({ commit, getters }, { syncguid, files }) {
    const promises = [];
    files.forEach(file => {
      promises.push(CustomContentService.putSupportMaterial(syncguid, file));
    });
    return Promise.all(promises).then(() => {
      const content = getters.customContent.find(c => c.syncguid === syncguid);
      const names = files.map(file => file.name);
      const object = content && content.supportMaterials ? content.supportMaterials.concat(names) : names;
      commit('setCustomContentObject', { syncguid, key: 'supportMaterials', object });
    });
  },
  updateThumbnail({ commit }, { syncguid, file }) {
    return CustomContentService.putThumbnail(syncguid, file).then(() => {
      commit('removeThumbnail', { syncguid });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
